import { render, staticRenderFns } from "./StarRatingView.vue?vue&type=template&id=7948f6a2&scoped=true"
import script from "./StarRatingView.vue?vue&type=script&lang=js"
export * from "./StarRatingView.vue?vue&type=script&lang=js"
import style0 from "./StarRatingView.vue?vue&type=style&index=0&id=7948f6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7948f6a2",
  null
  
)

export default component.exports